import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SoundSection from "@/components/SoundSection";
import StorySection from "@/components/StorySection";
import BookingSection from "@/components/BookingSection";
import Footer from "@/components/Footer";
import AudioPlayer from "@/components/AudioPlayer";

export default function Home() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api
      .get("/content")
      .then((res) => setContent(res.data))
      .catch(() => setContent(null));
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090b]" data-testid="home-loading">
        <Loader2 className="w-8 h-8 text-rose-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="grain min-h-screen bg-[#09090b] pb-20" data-testid="home-page">
      <Navbar />
      <main>
        <Hero content={content} />
        <SoundSection content={content} />
        <StorySection content={content} />
        <BookingSection content={content} />
      </main>
      <Footer content={content} />
      <AudioPlayer />
    </div>
  );
}
